import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import MetricsDashboard from "./pages/MetricsDashboard";
import StatusPage from "./pages/StatusPage";
import LandingPage from "./pages/LandingPage";
import VetCanStudio from "./pages/VetCanStudio";
import VetCanStudioPreview from "./pages/VetCanStudioPreview";
import VetcanLanding from "./pages/VetcanLanding";
import WhiteLabelLanding from "./pages/WhiteLabelLanding";
import WhiteLabelChatPage from "./pages/WhiteLabelChatPage";
import {
  getWhiteLabelTenantConfig,
  normalizeTenantHostname,
  type WhiteLabelTenantConfig,
} from "./lib/tenantConfig";
import { resolveTenantKeyRuntime } from "./lib/runtimeTenant";

export function isMarijuanaExpressHost(hostname: string): boolean {
  const tenantKey = resolveTenantKeyRuntime({
    hostname,
    search: "",
    isProduction: true,
  });
  return Boolean(getWhiteLabelTenantConfig(tenantKey));
}

export function isStudioAppHost(hostname: string): boolean {
  return normalizeTenantHostname(hostname) === "studio.astormscoming.com";
}

export default function App({ hostnameOverride }: { hostnameOverride?: string }) {
  const runtimeHostname =
    hostnameOverride || (typeof window !== "undefined" ? window.location.hostname : "");
  const tenantKey = resolveTenantKeyRuntime({
    hostname: runtimeHostname,
    search: typeof window !== "undefined" ? window.location.search : "",
  });
  const tenant: WhiteLabelTenantConfig | null = getWhiteLabelTenantConfig(tenantKey);
  const whiteLabelMode = Boolean(tenant);
  const studioHostMode = !whiteLabelMode && isStudioAppHost(runtimeHostname);

  return (
    <BrowserRouter>
      {whiteLabelMode ? (
        <Routes>
          <Route
            path="/"
            element={<WhiteLabelLanding tenant={tenant!} tenantKey={tenantKey} />}
          />
          <Route
            path="/chat"
            element={<WhiteLabelChatPage tenant={tenant!} tenantKey={tenantKey} />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : (
        <Routes>
          <Route
            path="/"
            element={studioHostMode ? <Navigate to="/studio" replace /> : <MetricsDashboard />}
          />
          <Route path="/metrics" element={<MetricsDashboard />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/studio" element={<VetCanStudio />} />
          <Route path="/studio/preview" element={<VetCanStudioPreview />} />
          <Route path="/vetcan" element={<VetcanLanding />} />
          <Route path="/status" element={<StatusPage />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}
